import WarehouseOutlined from '@mui/icons-material/WarehouseOutlined';
import EProduct from '../products';
import routes from '../routes';
import { IProductConfig } from './Products.types';

const operationsConfig: IProductConfig = {
  baseUrlProd: routes.opProd,
  baseUrlSandbox: routes.opSandbox,
  icon: <WarehouseOutlined />,
  modules: [
    {
      label: 'Authentication',
      path: '/authentication',
      roles: ['InboundAdmin', 'InboundAuthentication', 'InboundOperations'],
    },
    {
      label: 'Item Resolution Center',
      path: '/item-resolution-center',
      roles: ['InboundAdmin', 'InboundItemResolution', 'InboundOperations'],
    },
    {
      label: 'Warehouse',
      path: '/warehouse',
      roles: ['InboundAdmin', 'InboundOperations', 'InboundWarehouse'],
    },
  ],
  product: EProduct.operations,
  title: 'Operations',
};

export default operationsConfig;
